let logoData = {
    img: "assets/images/logo.png",
}
module.exports = logoData;